module.exports = __webpack_public_path__ + "static/media/4.Electric Paint Gun.2d0038cc.jpeg";